/**
 * Categorias de herramientas — catalogo delegado al asistente.
 *
 * La pantalla era un ABM de cuatro campos (slug / label_es / label_en / icon)
 * mas un toggle activo-inactivo. Paridad completa con tools ya registradas:
 * `list_tool_categories` (incluye `active_only: false`), `create_tool_category`
 * y `update_tool_category` (renombrar, icono, y `active` para des/reactivar).
 * No habia boton de borrar, asi que no queda ningun hueco.
 *
 * La ruta /herramientas/categorias se mantiene a proposito: hay tres lugares
 * del flujo de herramientas que enlazan aca (el modal de registro, el de
 * edicion y el estado vacio). Ahora aterrizan en la explicacion y el boton para
 * abrir el asistente en vez de en un 404.
 *
 * @module pages/tools/ToolCategoriesPage
 */

import React from 'react';
import { Container, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import DashboardLayout from '../../components/layout/DashboardLayout';
import CatalogoDelegadoPanel from '../settings/CatalogoDelegadoPanel';

const ToolCategoriesPage = () => {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <DashboardLayout>
        <Alert variant="danger" className="m-3">
          Solo administradores pueden gestionar categorías.
        </Alert>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Container fluid className="py-3 px-3" style={{ maxWidth: 960 }}>
        <div className="d-flex align-items-center gap-2 mb-3">
          <Button
            as={Link}
            to="/herramientas"
            variant="link"
            className="p-0 d-inline-flex align-items-center justify-content-center"
            style={{ minWidth: 44, minHeight: 44 }}
            aria-label="Volver a herramientas"
          >
            <i className="bi bi-arrow-left fs-4" aria-hidden="true" />
          </Button>
          <h4 className="mb-0">
            <i className="bi bi-tags me-2" aria-hidden="true" />
            Categorías de herramientas
          </h4>
        </div>

        <CatalogoDelegadoPanel
          titulo="Las categorías de herramientas las administra el asistente"
          intro="Pedíselo por chat y la categoría queda disponible en el momento."
          ejemplos={[
            'Creá la categoría de herramientas Medición con el ícono bi-speedometer',
            'Desactivá la categoría Pintura',
            'Mostrame todas las categorías de herramientas, incluidas las inactivas',
          ]}
          nota="Al registrar una herramienta también podés dictarle la categoría nueva directamente: si no existe, la crea y la deja enlazada en el mismo paso."
        />
      </Container>
    </DashboardLayout>
  );
};

export default ToolCategoriesPage;
